import { IntlShape } from 'react-intl';
import type { FormatXMLElementFn, PrimitiveType } from 'intl-messageformat';
import type { TranslationKey } from 'intl/types/translationKey';
import type { TranslatedString } from 'intl/types/translatedString';
import { formatTranslation } from 'intl/formatTranslation';

export type Translate = (
  id: TranslationKey,
  params?: Record<string, PrimitiveType | FormatXMLElementFn<string, string>>
) => TranslatedString;

// To avoid importing react-intl in the shared code
export const getTranslate = (intl: IntlShape): Translate => {
  return (id: TranslationKey, params?: Record<string, PrimitiveType | FormatXMLElementFn<string, string>>): TranslatedString =>
    formatTranslation(intl, id, params);
};
